module.exports = __webpack_public_path__ + "static/media/everybrand_logo.40e506eb.svg";